import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";

// Importaciones
import HomePage from "./pages/HomePage"; // La del admin
import StatusPage from "./pages/StatusPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import HomePageClient from "./pages/HomePageClient"; // La del cliente
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            
            {/* =========================================
                RUTAS PÚBLICAS (Para tus clientes)
               ========================================= */}
            {/* 1. AHORA HOMEPAGECLIENT ES LA RAÍZ "/" */}
            <Route path="/" element={<HomePageClient />} />
            
            <Route path="/admin/login" element={<AdminLoginPage />} />


            {/* =========================================
                RUTAS PRIVADAS (Para ti y tus vendedores)
               ========================================= */}
            
            {/* 2. MOVIMOS EL MAPA DEL ADMIN A "/admin/mapa" */}
            <Route 
              path="/admin/mapa" 
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/status" 
              element={
                <ProtectedRoute>
                  <StatusPage />
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              } 
            />

          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;